<template>
  <div>
    <Notification></Notification>
  </div>
</template>

<script>
import Notification from "@/components/notification/notification";
export default {
  name: "PipeNotifications",
  components: { Notification },

  data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted() {
    console.log("--------- Pipeline Step Notification ----------");
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
